import api from "./api";

export async function getLogs (username= '', page = 1, paginate = false, start, end) {
    return api.get(`/logs?username=${username}&date_from=${start}&date_to=${end}&paginate=${paginate}&page=${page}&sortDirection=desc`)
}

export function setLog (data) {
     return api.post('/logs', data)
        .then(response => response.data)
        .catch(error => {return error.response});
}

export async function getLogsByIndicator (id= '', username = '', page = 1, start, end) {
    return api.get(`/logs?indicator_id=${id}&username=${username}&date_from=${start}&date_to=${end}&paginate=true&page=${page}&sortDirection=desc`)
        .then(response => response.data)
        .catch(error => {return error.response});
}
